(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    module.directive('taskContentRequired', [TaskContentRequiredFn]);

    /* task content validation */
    function TaskContentRequiredFn() {

        var directive = {
            link: link,
            require: 'ngModel',
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs, mCtrl) {

            // content is required ?
            function isOk(value) {
                return typeof value !== 'undefined' && value !== null && value.length > 0;
            }

            // role is required
            mCtrl.$validators.required = function (value) {
                return isOk(value);
            };
        }
    }

})();